import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  custom: {
    families: ['Poppins'],
    urls: ['https://fonts.googleapis.com/css?family=Poppins']
  },
})
